import React, { createContext, useContext, useEffect, useState } from "react";
import { logError } from "./log";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name, role) => {
    const { data } = await api.post("/auth/register", { email, password, name, role });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    setUser(null);
    try {
      await api.post("/auth/logout");
    } catch (e) {
      logError("Logout request failed", e);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>{children}</AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
